export default class ObjectState {
    isNew: boolean = true;
    isModified: boolean = true;
    isDeleted? : boolean = false;

    static new(): ObjectState {
        return { isNew: true, isModified: true };
    }

    static asNew<T>(obj: T): (ObjectState & T) {
        return { ...obj, ...this.new() };
    }

    static clean(): ObjectState {
        return { isNew: false, isModified: false };
    }

    static asClean<T>(obj: T): (ObjectState & T) {
        return { ...obj, ...this.clean() };
    }

    static modified(): ObjectState {
        return { isNew: false, isModified: true };
    }

    static asModified<T>(obj: T): (ObjectState & T) {
        return { ...obj, ...this.modified() };
    }
}